import { Button, Card, Container, Grid, Typography, Snackbar } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import "./Dashboard.css";
import { Alert } from "@material-ui/lab";
import { UserContext } from "../../contexts/UserContext";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { fullscreenWindow } from "../../utils/utils";
import useRecorder from "../../utils/useRecorder";
import MicIcon from "@material-ui/icons/Mic";
import StopIcon from "@material-ui/icons/Stop";
import CountDown from "../../components/CountDown/CountDown";
import SoundWave from "../../components/SoundWave/SoundWave";

const Dashboard = () => {
	const { isLoggedIn, userDetails } = useContext(UserContext);
	const history = useHistory();
	const [audioURL, isRecording, startRecording, stopRecording, resetRecorder] = useRecorder();
	const [recorded, setRecorded] = useState(false);
	const [alreadySnack, setAlreadySnack] = useState(false);
	const [testLoading, setTestLoading] = useState(false);
	const [testNotStarted, setTestNotStarted] = useState(false);
	const [testingAudio, setTestingAudio] = useState(false);
	const [testBegin, setTestBegin] = useState(0);

	const handleTestStart = async () => {
		setTestLoading(true);

		const url = `${process.env.REACT_APP_BACKEND_URL}/attempt/begin`;
		const token = localStorage.getItem("token");

		try {
			await axios
				.post(
					url,
					{},
					{
						headers: {
							Authorization: `Bearer ${token}`,
						},
					}
				)
				.then((res) => {
					// console.log(res);
					setTestLoading(false);
					fullscreenWindow();
					history.push({
						pathname: "/test/sections",
						state: {
							fromDash: true,
							time: res.data.remainingTime,
							openTime: Date.now(),
						},
					});
				});
		} catch (error) {
			// console.log(error);
			setTestLoading(false);
			if (error.response.status === 402) {
				setAlreadySnack(true);
			} else if (error.response.status === 403) {
				setTestNotStarted(true);
			}
		}
	};

	const handleProceed = async () => {
		const url = `${process.env.REACT_APP_BACKEND_URL}/checkenv`;
		const token = localStorage.getItem("token");

		try {
			await axios
				.get(url, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				.then((res) => {
					// console.log(res);
					if (res.data.success) {
						setTestingAudio(res.data.success);
						// console.log(res.data);
						setTestBegin(res.data.remainingTime > 0 ? res.data.remainingTime : 0);
					} else setTestNotStarted(true);
				});
		} catch (error) {
			// console.log(error);
			setTestLoading(false);
		}
	};

	useEffect(() => {
		if (!isLoggedIn) {
			history.replace("/");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isLoggedIn]);

	return (
		<div className="dashboard-page">
			<Card variant="outlined" className="dash-card">
				{userDetails.testOver ? (
					<Container
						style={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							height: "70vh",
							textAlign: "center",
						}}
					>
						<img src="/logo.png" className="avatar" alt="Josh Talks" />
						<Typography variant="h4">Thank You</Typography>
						<Typography variant="h5">You have already submitted the test</Typography>
					</Container>
				) : (
					<Grid container>
						<Grid
							item
							xs={12}
							md={6}
							style={{ borderRight: "1px solid #aaa" }}
							className="dash-instructions"
						>
							<h2>Test Instructions:</h2>
							<div className="dash-instructions-panel">
								<ol>
									<li>
										{
											"The examination will be conducted in an online proctored mode.The candidate can take the test from the safe and secure environment of his/her home, with a desktop/laptop(with a microphone) and an internet connection(un-interrupted internet speed is desirable)"
										}
									</li>
									<li>
										{
											"The examination comprises 137 Objective MCQs. The duration of the exam is 120 minutes."
										}
									</li>
									<li>
										{
											"The candidate’s details appear on the screen, which will be verified by them"
										}
									</li>
									<li>
										{
											"The 120 minutes Timer of the examination begins as per the time slot that is allotted to the candidate."
										}
									</li>
									<li>
										{
											"The candidate proceeds answering the questions one by one by clicking on the small grey circle next to the chosen answer."
										}
									</li>
									<li>
										{
											"The examinee can move to First, Last, Previous, Next and unanswered questions by clicking on the buttons with respective labels displayed on screen throughout the test."
										}
									</li>
									<li>
										{
											"The answers can be changed at any time during the test and are saved automatically."
										}
									</li>
									<li>
										{
											"It is possible to review the answered as well as the unanswered questions."
										}
									</li>
									<li>
										{
											"The Time remaining is shown in the Right Top Corner of the screen."
										}
									</li>
									<li>
										{
											"The system automatically ends test when the time limit is over OR alternatively if the examinee finishes the exam before time he can quit by pressing the ‘End Test’ button."
										}
									</li>
									<li>{"Each MCQ carries different number of marks."}</li>
									<li>
										{
											"The examinee is requested to stay on the examination link provided and do not open any other tab/window on your screen.This will lead to disqualification and the examination link will expire at the very moment."
										}
									</li>
									<li>
										{"Extra Exam Attempt Will not be provided if,"}
										<ol type="a">
											<li>
												{
													"Examinee fails to appear for the exam within specified timings."
												}
											</li>
											<li>
												{
													"Examinee appears for exam late/face lack of time."
												}
											</li>
											<li> {"Examinee ignores instructions and rules."} </li>
											<li>{"Examinee does not submit the exam properly."}</li>
											<li>
												{
													"Examinee face the internet or power failure problems."
												}
											</li>
										</ol>
									</li>
									<li>
										{
											"IMPORTANT: Do not click the“ End Test” button unless you want to leave early."
										}
									</li>
								</ol>
							</div>
						</Grid>
						{testingAudio ? (
							<Grid item xs={12} md={6} className="dash-instructions">
								<Container className="dash-user-info">
									<img src="/logo.png" className="avatar" alt="Josh Talks" />
									{testBegin > 0 ? (
										<div className="dash-start-div-alt">
											<div>Test Starts in</div>
											<div>
												<CountDown
													endTime={new Date(Date.now() + testBegin)}
													onComplete={() => setTestBegin(0)}
												/>
											</div>
										</div>
									) : (
										<></>
									)}
									<Typography variant="h6" style={{ marginTop: "10px" }}>
										Before, we begin your test..lets test your audio!
									</Typography>
									{isRecording ? (
										<>
											<SoundWave />
											<div>
												<Button
													variant="contained"
													color="primary"
													onClick={() => {
														stopRecording();
														setRecorded(true);
													}}
													startIcon={<StopIcon />}
												>
													Stop Recording
												</Button>
											</div>
										</>
									) : (
										<>
											<Typography variant="h6">
												Click on button below to start recording!
											</Typography>
											<div style={{ marginTop: 20 }}>
												<Button
													variant="contained"
													color="primary"
													onClick={() => {
														resetRecorder();
														startRecording();
													}}
													startIcon={<MicIcon />}
												>
													Start Recording
												</Button>
											</div>
										</>
									)}
									{recorded ? (
										<>
											<div style={{ marginTop: 30 }}>
												<audio src={audioURL} controls />
											</div>
											{testBegin === 0 ? (
												<div className="dash-start-div">
													<Button
														variant="contained"
														className="start-test-btn"
														onClick={handleTestStart}
														disabled={testLoading}
													>
														{testLoading
															? "Starting test..."
															: "Attempt Test"}
													</Button>
												</div>
											) : (
												<></>
											)}
										</>
									) : (
										<></>
									)}
								</Container>
							</Grid>
						) : (
							<Grid item xs={12} md={6} className="dash-instructions">
								<Container className="dash-user-info">
									<img src="/logo.png" className="avatar" alt="Josh Talks" />
									<h2>Your Information</h2>
									<div className="dash-info-table">
										<p>
											<strong>Name: </strong>
											{userDetails.name}
										</p>
										<p>
											<strong>Phone: </strong>
											{userDetails.phone}
										</p>
									</div>
									<div className="dash-start-div">
										<Button
											variant="contained"
											className="start-test-btn"
											onClick={handleProceed}
											// onClick={() => {
											// 	setAlreadySnack(true);
											// }}
											// disabled={true}
										>
											Proceed to Test
										</Button>
									</div>
								</Container>
							</Grid>
						)}
					</Grid>
				)}
			</Card>
			<Snackbar
				open={testNotStarted}
				onClose={() => setTestNotStarted(false)}
				autoHideDuration={2000}
			>
				<Alert severity="error" variant="filled">
					Test not started yet!
				</Alert>
			</Snackbar>
			<Snackbar
				open={alreadySnack}
				onClose={() => setAlreadySnack(false)}
				autoHideDuration={2000}
			>
				<Alert severity="error" variant="filled">
					Test Finished!
				</Alert>
			</Snackbar>
		</div>
	);
};

export default Dashboard;
